import { createContext, useContext } from 'react';

// 'fill' is the initial submission, 'edit' is reworking an already stored submission.
export type FormularMode = 'fill' | 'edit';

const FormularModeContext = createContext<FormularMode>('fill');

export const useFormularMode = () => useContext(FormularModeContext);

export const useIsFormularEditMode = () => useFormularMode() === 'edit';

export default FormularModeContext;
